import PropTypes from 'prop-types'
import React from 'react'

import {
  NEWSLETTER_CONSENT_LABEL,
  PRIVACY_POLICY_URL
} from '../../../utils/accountConsent'
import './styles.css'

// SPEC-099: an optional newsletter opt-in. It never blocks submitting the
// form it sits in. SPEC-101 D8: a form whose terms line already links the
// Privacy Policy passes privacyLink={false}. SPEC-109: it starts unticked
// and the form may tick it from the backend's per-country default
// (useNewsletterDefault); onTouched tells the form the person has decided,
// so the default never overrides them.
function NewsletterConsent({
  id,
  inputProps = {},
  dark = false,
  privacyLink = true,
  onTouched
}) {
  const onChange = (event) => {
    if (onTouched) onTouched()
    if (inputProps.onChange) inputProps.onChange(event)
  }
  return (
    <div className={`NewsletterConsent${dark ? ' -dark' : ''}`}>
      <input {...inputProps} onChange={onChange} type="checkbox" id={id} />
      <div className="NewsletterConsent__copy">
        <label htmlFor={id}>{NEWSLETTER_CONSENT_LABEL}</label>
        {privacyLink && (
          <>
            {' '}
            <a
              href={PRIVACY_POLICY_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </>
        )}
      </div>
    </div>
  )
}

NewsletterConsent.propTypes = {
  id: PropTypes.string.isRequired,
  // react-hook-form's register(...) result
  inputProps: PropTypes.object,
  dark: PropTypes.bool,
  privacyLink: PropTypes.bool,
  onTouched: PropTypes.func
}

export default NewsletterConsent
